import { render, staticRenderFns } from "./AnswerDetailLevelThree.vue?vue&type=template&id=465f65c8&scoped=true&"
import script from "./AnswerDetailLevelThree.vue?vue&type=script&lang=js&"
export * from "./AnswerDetailLevelThree.vue?vue&type=script&lang=js&"
import style0 from "./AnswerDetailLevelThree.vue?vue&type=style&index=0&id=465f65c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465f65c8",
  null
  
)

export default component.exports